import setDeviceInfo from './set-device-info'
import setOneTrustConsentData from './set-one-trust-consent-data'
import setWindowDimensions from './set-window-dimensions'

export default function(ctx) {
  setOneTrustConsentData(ctx)
  setDeviceInfo(ctx)
  setWindowDimensions(ctx)
}
